import { Box, ButtonBase, Typography } from '@mui/material';
import fallbackImage from 'assets/images/placeholder.svg';
import { useEffect, useState } from 'react';

import { OPERATION_STATUS, STATUS_COLOR } from '../constants';
import { asideStripSx, clamp2 } from './styles';

const AsideLabel = ({ children }) => (
  <Typography
    component="span"
    sx={{
      transform: 'rotate(-90deg)',
      color: '#fff',
      fontSize: 12,
      fontWeight: 800,
      whiteSpace: 'nowrap',
      userSelect: 'none',
      lineHeight: 1,
    }}
  >
    {children}
  </Typography>
);

const getAsideState = ({
  status,
  actionLabel,
  onAction,
  canMutate,
  actionDisabled,
}) => {
  const statusAside = OPERATION_STATUS[status];
  const asideText = actionLabel || statusAside?.label;
  const canClick = Boolean(onAction) && canMutate;

  return {
    asideText,
    hasAside: Boolean(asideText),
    asideColor: statusAside?.color || OPERATION_STATUS.InProsses.color,
    canClick,
    isClickable: canClick && !actionDisabled,
  };
};

const OperationProductCard = ({
  product,
  canMutate = false,
  actionLabel,
  onAction,
  actionDisabled = false,
  children,
}) => {
  const [imgSrc, setImgSrc] = useState(product?.imageUrl || fallbackImage);
  const { asideText, hasAside, asideColor, canClick, isClickable } =
    getAsideState({
      status: product?.status,
      actionLabel,
      onAction,
      canMutate,
      actionDisabled,
    });

  console.log(asideColor);

  useEffect(() => {
    setImgSrc(product?.imageUrl || fallbackImage);
  }, [product?.imageUrl]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        width: '100%',
        minHeight: 120,
        borderRadius: '15px',
        bgcolor: hasAside ? asideColor : 'transparent',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'start',
          flexDirection: 'column',
          flex: 1,
          minWidth: 0,
          px: 1.25,
          py: 1,
          bgcolor: '#FAFAFA',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: 1,
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 110,
              alignSelf: 'stretch',
              borderRadius: '12px',
              bgcolor: 'brand.blue.primary',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              flexShrink: 0,
              pb: 0.5,
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '10px',
                bgcolor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                overflow: 'hidden',
                flexShrink: 0,
              }}
            >
              <img
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'fill',
                }}
                alt={product?.title}
                src={imgSrc}
                onError={() => setImgSrc(fallbackImage)}
              />
            </Box>
            <Typography
              sx={{
                color: '#fff',
                fontSize: 12,
                fontWeight: 700,
                lineHeight: 1,
                textAlign: 'center',
                marginTop: 'auto',
              }}
            >
              {`x${product?.quantity ?? 1}`}
            </Typography>
          </Box>

          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              mr: 1.5,
              mt: 1.5,
              display: 'flex',
              flexDirection: 'column',
              gap: 0.75,
            }}
          >
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 600,
                lineHeight: 1.35,
                minHeight: 36,
                color: 'text.primary',
                ...clamp2,
              }}
            >
              {product?.title}
            </Typography>
            {product?.packName ? (
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 400,
                  lineHeight: 1.35,
                  color: 'text.primary',
                  ...clamp2,
                }}
              >
                {product.packName}
              </Typography>
            ) : null}
            {children}
          </Box>
        </Box>

        {product?.locality ? (
          <Typography
            variant="body2"
            fontWeight={600}
            textAlign="center"
            sx={{ mt: 2, direction: 'rtl', width: '100%' }}
          >
            {product.locality}
          </Typography>
        ) : null}
      </Box>

      {hasAside && canClick ? (
        <ButtonBase
          disabled={!isClickable}
          onClick={() => onAction?.(product)}
          aria-label={asideText}
          sx={{
            ...asideStripSx,
            opacity: isClickable ? 1 : 0.5,
          }}
        >
          <AsideLabel>{asideText}</AsideLabel>
        </ButtonBase>
      ) : null}
      {hasAside && !canClick ? (
        <Box sx={asideStripSx}>
          <AsideLabel>{asideText}</AsideLabel>
        </Box>
      ) : null}
    </Box>
  );
};

export default OperationProductCard;
